import React, {useRef} from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { IdleTimerProvider } from "react-idle-timer";

import TawkToWidget from './components/TawkToWidget';

import {logoutApiCall} from "./utils/Apicalls";
import HomeScreen from "./pages/home/index";
import LoginScreen from "./pages/login/index";
import AdminHomeScreen from "./pages/admin-home/index";
import SignUpScreen from "./pages/signup/index";
import SignupPage from "./pages/signup/SignupPage";
import InterviewPage from "./pages/interview/index";
import AutomaticDiarization from "./pages/live-transcription/AutomaticDiarization";
import MyProfilePage from "./pages/signup/MyProfilePage";
import PlansPage from "./pages/home/PlansPage";
import ForgotPasswordPage from "./pages/forgot-password";
import CheckoutPage from './pages/checkout/CheckoutPage';
import PaymentSuccessPage from './pages/payment/PaymentSuccessPage';
import PaymentFailurePage from './pages/payment/PaymentFailurePage';
import TabAudioTranscription from "./pages/live-transcription/TabAudioTranscription";
import TabAudioWhisper from "./pages/live-transcription/TabAudioWhisper";
import ContactUs from "./components/ContactUs";
import AdminPage from "./pages/admin/AdminPage";
import TennantUsersPage from "./pages/tennant-users/TennantUsersPage";
import InstallationPage from "./pages/installation/index";
import GenerateTokenPage from "./pages/admin-home/tokenPage";
import JobApplicationPage from "./pages/JobApplication/JobApplicationPage";

// Create a custom theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#9b5de5',
    },
    secondary: {
      main: '#6979f8',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
            '&:hover fieldset': {
              borderColor: '#9b5de5',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#9b5de5',
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '50px',
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
  },
});

function App() {
  const idleTimerRef = useRef(null);

  const handleOnIdle = async () => {
    let findToken = localStorage.getItem("token")
    console.log("User is idle for 1 hour, logging out...");
    if (findToken) {
      try {
        // Call the logout API 
        const result = await logoutApiCall();
        
        // Clear localStorage regardless of API response
        localStorage.removeItem("userDetails");
        localStorage.removeItem("token");

        // Redirect to login page
        window.location.href = "/login";
        
        // Log the result for debugging
        if (result?.status) {
          console.log("Logout successful");
        } else {
          console.warn("Logout API call failed, but local logout completed");
        }
      } catch (error) {
        console.error("Error during logout:", error);
        // Still clear localStorage and redirect even if API call fails
        localStorage.removeItem("userDetails");
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    }
  };

  return (
    <>
      <IdleTimerProvider
        ref={idleTimerRef}
        timeout={1000 * 60 * 60} // 1 hour -> 1000 * 60 * 60
        onIdle={handleOnIdle}
        debounce={500}
      >
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<JobApplicationPage />} />
             {/* <Route path="/" element={<HomeScreen />} /> */}
              <Route path="/login" element={<LoginScreen />} />
              <Route path="/home" element={<AdminHomeScreen />} />
              <Route path="/signup/:id" element={<SignUpScreen />} />
              <Route path="/interview" element={<InterviewPage />} /> 
              {/* <Route path="/automated-interview" element={<AutomatedInterviewPage />} />
              <Route path="/live-transcription" element={<LiveTranscriptionPage />} />
              <Route path="/diarized-interview" element={<DiarizedInterviewPage />} /> */}
              <Route path="/automatic-diarization" element={<AutomaticDiarization />} />
              {/* <Route path="/google-speech" element={<GoogleSpeechDiarization />} />
              <Route path="/deepgram-transcription" element={<DeepgramTranscriptionPage />} /> */}
              <Route path="/signup/free" element={<SignUpScreen />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/myprofile" element={<MyProfilePage />} />
              <Route path="/plans" element={<PlansPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/checkout/:id" element={<CheckoutPage />} />
              <Route path="/payment-success" element={<PaymentSuccessPage />} />
              <Route path="/payment-failure" element={<PaymentFailurePage />} />
              <Route path="/tab-audio-transcription" element={<TabAudioTranscription />} />
              <Route path="/tab-audio-whisper" element={<TabAudioWhisper />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/tennant-users/:id" element={<TennantUsersPage />} />
              <Route path="/installation" element={<InstallationPage />} />
              <Route path="/generate-token" element={<GenerateTokenPage />} />
              <Route path="/job-application" element={<JobApplicationPage />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <TawkToWidget />
          </BrowserRouter>
        </ThemeProvider>
      </IdleTimerProvider>
    </>
  );
}

export default App;
